import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "../Guides/guides.css"; 
import "./getStarted.css"; 
import { MainContent, ImageInline, ProgressBar } from "./GetStartedHelpers.jsx";
import Tooltip from "../Guides/Tooltip.jsx";
import Seo from "../Seo.jsx";
import getStartedConfig from "../../config/getStartedConfig.js";
import betfred from "./betfred.png";

import mb1 from "./mb1.png";
import mb2 from "./mb2.png";


const GetStarted = () => {
  const meta = getStartedConfig.getStarted?.seo || {};
  const progress = getStartedConfig.progress || { currentStep: 0, totalSteps: 4 };

  const navigate = useNavigate();

  // This handler will be passed to the ProgressBar.
  const handleStepClick = (stepIndex) => {
    const targetRoute = `/get-started/step${stepIndex + 1}`;
    if (targetRoute) {
      navigate(targetRoute);
    }
  };

  return (
    <MainContent>
      <Seo title={meta.title} description={meta.description} url={getStartedConfig.getStarted?.route || "/get-started/step1"}/>

      <ProgressBar currentStep={progress.currentStep} totalSteps={progress.totalSteps} onStepClick={handleStepClick} />

      <h1>Understand Matched Betting in 180 Seconds</h1>

      <section>
        <ImageInline
          imageSrc={betfred}
          alt="Diagram of Matched Betting Basics"
          annotations={
            <div>
              <h4>Ever seen something like this, and wondered if you could make money from it <em>without gambling</em>?</h4>
              <p>You're in the right place!</p>
            </div>
          }
        />
      </section>

      <section>
      <h2>✅ What is Matched Betting?</h2>
      <h6 className="info">Matched betting is a way to turn free offers from betting companies into cash by placing bets that <em>cancel each other out</em>.</h6>
      <section>
        <div className="grid-fixed g2">
          <div className="col">
            <img src={mb1} alt="How does matched betting work?" />
          </div>
          <div className="col">
            <h3 className="mt-0">Normal betting</h3>
            <p>When you bet, you bet the bookie that something <em>will</em> happen.</p>
            <ul>
              <li>If you win, the bookie gives you your winnings, and your <Tooltip content={"Your initial bet"}>stake</Tooltip> back.</li>
              <li>If you lose, the bookie keeps your <Tooltip content={"Your initial bet"}>stake</Tooltip>.</li>
            </ul>
          </div>
        </div>
        <div className="grid-fixed g2">
          <div className="col">
            <img src={mb2} alt="How does matched betting work?" />
          </div>
          <div className="col">
            <h3 className="mt-0">Matched betting</h3>
            <p>When you matched bet, you place <em>a second</em> bet <strong>against</strong> the same outcome.</p>
            <p><strong>This time you act like the bookie!</strong></p>
          </div>
        </div>
      </section>
      </section>
      <Link to="/get-started/step2">
        <button className="next-button">Next</button>
      </Link>    
    </MainContent>
  );
};

export default GetStarted;
